import BaseModel from '../models/base_model';
import MapObject from '../models/map_object';
import BusStop from '../models/bus_stop';
import Library from '../models/library';
import DiningLocation from '../models/dining_location';
import Bcycle from '../models/bcycle';
import GenderNeutralRestroom from '../models/gender_neutral_restroom';

const Feature = {
	/**
	 * Generate a model from at least { id: id, object_type: object_type }
	 * Example, factory({id:12,type:'BusStop'});
	 */
	factory: function (obj) {
		// If it's already a BaseModel, just send it back
		if (obj instanceof BaseModel) {
			return obj;
		}
		const type = obj.object_type;
		const map_object_types = ['building', 'parking_lot', 'natural_area', 'building_partial'];

		// Bail if we don't have an id
		if (!obj.map_object_id && !obj.id) {
			return false;
		}

		if (map_object_types.includes(type)) {
			return new MapObject(obj.map_object_id);
		} else if (Object.keys(obj).includes('stop_code')) {
			return new BusStop(obj.stop_code);
		} else if (type === 'library') {
			return new Library(obj.id);
		} else if (type === 'dining') {
			return new DiningLocation(obj.id);
		} else if (type === 'bcycle') {
			return new Bcycle(obj.id);
		} else if (type === 'gender_neutral_restroom') {
			return new GenderNeutralRestroom(obj.id);
		}
		return new MapObject(obj.map_object_id);
	},

	/**
	 * Generate a factory from a key
	 * example MapObject_505, or BusStop_926
	 */
	fromKey: function (key) {
		const match = /^(MapObject|BusStop)_(\d+)$/.exec(key);
		if (match) {
			let params = { map_object_id: match[2], type: match[1] };
			if (match[1] === 'BusStop') {
				params.stop_code = match[2];
			}
			return this.factory(params);
		}
		return false;
	},

	/**
	 * Specifically tailored to finding a feature from a
	 * pg_search_documents json object
	 * NOTE: As of 2025, we are not returning bus stops. The
	 * code below needs updating. If we ever add Dining, Library or Destination
	 * to search, this will need updating to pass the correct object type
	 */
	fromSearch: function (search) {
		let type = search.searchable_type;
		let object_type = 'building';

		if (type === 'Gtfs::Stop' || type === 'MapObject') {
			// Use BusStop for frontend code
			if (type === 'Gtfs::Stop') {
				type = 'BusStop';
				object_type = 'bus_stop';
			}
			return this.factory({
				map_object_id: search.searchable_id,
				stop_code: search.searchable_id,
				object_type: object_type,
			});
		} else if (type === 'Department') {
			return this.factory({ map_object_id: search.map_object_id, object_type: object_type });
		}
		return false;
	},
};

export default Feature;
